<script>
    import { slide } from "svelte/transition";
    import { getContext, onMount } from "svelte";
    import Arrow from "../icons/arrow.svelte";
    import { uuid } from "../../utils";
    const clsPrefix = "sui-acc-item";
    export let title = "";
    export let active = false;
    const id = uuid();
    const ctx = getContext("Accordion");
    let unsubscribe;
    onMount(() => {
        if (ctx) {
            ctx.add({ id, active });
            unsubscribe = ctx.items.subscribe((value) => {
                active = value[id];
            });
        }
        return () => {
            unsubscribe && unsubscribe();
        };
    });
</script>

<li class={clsPrefix}>
    <div
        class={`${clsPrefix}-title`}
        type="button"
        aria-expanded={active}
        aria-controls={id}
        id={`button-${id}`}
        on:click
        on:click={()=>ctx.toggle({ id, active: !active })}
    >
        <slot name="title">{title}</slot>
        <Arrow color="rgba(0, 10, 31, 0.3)" size={19} bgcolor="rgba(0, 10, 31, 0.06)" class={active ? 'active' : ''}/>
    </div>
    {#if active}
        <div
            class={`${clsPrefix}-panel`}
            role="region"
            {id}
            aria-labelledby={`button-${id}`}
            transition:slide
        >
            <slot />
        </div>
    {/if}
</li>

<style lang="less">
    @import './accordion.less';
</style>
